import { DefaultFullPreview } from ".";
import type { PaywallCheckoutPreview } from "@circle-react/types";
import { DEFAULT_FULL_PREVIEW_VARIANT } from "./constants";

interface ModalPreviewTemplateProps {
  preview: PaywallCheckoutPreview;
}

export const ModalPreviewTemplate = ({
  preview,
}: ModalPreviewTemplateProps) => (
  <div className="flex flex-col">
    <DefaultFullPreview.FirstPaymentPreview
      preview={preview}
      className="pb-4"
      variant={DEFAULT_FULL_PREVIEW_VARIANT.paywall_customization}
    />
    <DefaultFullPreview.PaymentAfterTrialPreview
      preview={preview}
      className="py-4"
      variant={DEFAULT_FULL_PREVIEW_VARIANT.paywall_customization}
    />
    <DefaultFullPreview.FuturePaymentsPreview
      preview={preview}
      className="py-4"
      variant={DEFAULT_FULL_PREVIEW_VARIANT.paywall_customization}
    />
    <DefaultFullPreview.RemainingPaymentsPreview
      preview={preview}
      className="py-4"
      variant={DEFAULT_FULL_PREVIEW_VARIANT.paywall_customization}
    />
    <DefaultFullPreview.PaymentSchedulePreview
      preview={preview}
      className="py-4"
      variant={DEFAULT_FULL_PREVIEW_VARIANT.paywall_customization}
    />
    <DefaultFullPreview.TotalDueTodayPreview preview={preview} />
  </div>
);
